import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { checkUserGroup } from '../utils/authUtils';

/**
 * Wraps admin-only routes. Checks Cognito group membership once on mount.
 * Non-admins are redirected to / (route is effectively invisible to them).
 *
 * UI-level check only. Real authorization is enforced server-side on every
 * /admin/* API request via require_admin() in the Lambda.
 */
export default function AdminRoute({ children }) {
    const [state, setState] = useState({ loading: true, isAdmin: false });

    useEffect(() => {
        let cancelled = false;
        checkUserGroup()
            .then(({ isAdmin }) => {
                if (!cancelled) setState({ loading: false, isAdmin });
            })
            .catch(() => {
                if (!cancelled) setState({ loading: false, isAdmin: false });
            });
        return () => { cancelled = true; };
    }, []);

    if (state.loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
                <CircularProgress />
            </Box>
        );
    }
    if (!state.isAdmin) return <Navigate to="/" replace />;
    return children;
}
